import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CardHeader, Col, Row } from "reactstrap";
import Select from "../../components/Inputs/Select";
import ResourceSelect from "../../components/Inputs/ResourceSelect";
import ColumnToggle from "../../components/NTable/Actions/ColumnToggle";
import Filters from "../../components/NTable/Actions/Filters";
import { useColumnFiltersConfig } from "../../components/NTable/hook/useColumnFiltersConfig";
import { useCustomFields } from "../Settings/CustomFields/context";
import {
	getSettingsResourceSearchFilters,
	renderPeopleCustomFieldLabel,
} from "../../utils/helpers/settings";

function Actions({ children, filters, setFilters, columns }) {
	const { t } = useTranslation();
	const baseConfig = useColumnFiltersConfig(columns);
	const { peopleCustomFields } = useCustomFields();

	const config = useMemo(
		() => [
			...baseConfig,
			{
				name: "custom-field",
				label: t("custom-fields"),
				type: "resource-select",
				component: (
					<ResourceSelect
						resourcePath="/custom-field/people"
						mode="multiple"
						renderLabel={renderPeopleCustomFieldLabel}
						getSearchFilters={getSettingsResourceSearchFilters}
						hasSearch
					/>
				),
			},
			{
				name: "customFields",
				label: t("custom-fields"),
				children: (peopleCustomFields || []).map((customField) => ({
					name: customField.code,
					label: renderPeopleCustomFieldLabel(customField),
					type: customField.type === "select" ? "select" : "text",
					component:
						customField.type === "select" ? (
							<Select mode="multiple">
								{customField.options.map((option) => (
									<Select.Option key={option.value} value={option.value}>
										{option.label}
									</Select.Option>
								))}
							</Select>
						) : undefined,
				})),
			},
		],
		[t, baseConfig, peopleCustomFields],
	);

	return (
		<CardHeader className="border-top p-3">
			<Row className="d-flex align-items-center justify-content-between mb-3 mb-md-0">
				<Col md={12} lg={4}>{children}</Col>

				<Col md={12} lg={children ? 8 : 12}>
					<div className="d-flex align-items-start">
						<Filters
							config={config}
							filters={filters}
							setFilters={setFilters}
						/>

						<ColumnToggle columns={columns} />
					</div>
				</Col>
			</Row>
		</CardHeader>
	);
}

export default Actions;
